export default __webpack_public_path__ + "static/media/Christmas_02.4f2158ae.png";